import {
  databasesActionCreators,
  databasesStardogRequestDispatchers,
} from 'src/actions/databases/actionCreators';
import { databaseSelector } from 'src/selectors/database';
import { isDatabaseRefreshedSelector } from 'src/selectors/isRefreshingDatabase';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshDatabase =
  (databaseId: string) =>
  async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const state = getState();
    const database = databaseSelector(databaseId)(state);
    const isRefreshed = isDatabaseRefreshedSelector(databaseId)(state);
    if (isRefreshed) {
      return;
    }

    dispatch(databasesActionCreators.refreshDatabaseStarted(databaseId));

    if (database) {
      const promises: Array<Promise<any>> = [];

      promises.push(
        databasesStardogRequestDispatchers.requestNamedGraphs(databaseId)
      );
      promises.push(
        databasesStardogRequestDispatchers.requestDatabaseNamespaces(databaseId)
      );

      await Promise.all(promises);
    }

    dispatch(databasesActionCreators.refreshDatabaseFinished(databaseId));
  };
